import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';

interface IFlowSectionProps {
  step: string;
  title: React.ReactNode;
  description: string;
  disabled?: boolean;
  required?: boolean;
  children: React.ReactNode;
}

const FlowSection: React.FC<IFlowSectionProps> = ({
  step,
  title,
  description,
  disabled,
  required = false,
  children,
}) => {
  const paperSx: SxProps<Theme> = disabled
    ? [
        guaranteesClientPageStyles.flowSectionPaper,
        guaranteesClientPageStyles.flowSectionPaperDisabled,
      ]
    : guaranteesClientPageStyles.flowSectionPaper;

  return (
    <Paper elevation={0} sx={paperSx}>
      <Box sx={guaranteesClientPageStyles.flowSectionHeader}>
        <Box component="span" sx={guaranteesClientPageStyles.flowSectionNumber}>
          {step}
        </Box>
        <Box sx={guaranteesClientPageStyles.flowSectionHeaderContent}>
          <Typography sx={guaranteesClientPageStyles.flowSectionTitle}>
            {title}
            {required ? ' *' : ''}
          </Typography>
          <Typography sx={guaranteesClientPageStyles.flowSectionDescription}>
            {description}
          </Typography>
        </Box>
      </Box>

      <Box sx={guaranteesClientPageStyles.flowSectionBody}>{children}</Box>
    </Paper>
  );
};

export default FlowSection;
